import { useSearchParams } from 'react-router-dom';
import usePageMeta from '@/hooks/usePageMeta';
import Hero from './components/Hero';
import GenreNav from './components/GenreNav';
import { HotSection, LatestSection, CompletedSection } from './components/MangaSections';
import Testimonials from './components/Testimonials';
import FaqPreview from './components/FaqPreview';
import SearchResults from './components/SearchResults';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '免费51漫画',
    url: 'https://shonenx.github.io/',
    description: '免费51漫画按类型标签分类，热血类、搞笑类、少女漫、少年漫、完结作品、汉化组一应俱全。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '免费51漫画',
    url: 'https://shonenx.github.io/',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://shonenx.github.io/?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  },
];

export default function HomePage() {
  const [searchParams] = useSearchParams();
  const q = searchParams.get('q')?.trim() || '';

  usePageMeta({
    title: '免费51漫画 - 热血·搞笑·少女漫·少年漫·完结作品·汉化组在线看',
    description:
      '免费51漫画按类型标签分类，热血类、搞笑类、少女漫、少年漫、完结作品、汉化组一应俱全，按标签筛选快速找到想看的漫画，追更更方便。',
    path: '/',
    jsonLd,
  });

  return (
    <div className="w-full">
      <Hero />
      {q ? (
        <SearchResults keyword={q} />
      ) : (
        <>
          <GenreNav />
          <HotSection />
          <LatestSection />
          <CompletedSection />
          <Testimonials />
          <FaqPreview />
        </>
      )}
    </div>
  );
}